import {Button, Modal} from "react-bootstrap";
import PropTypes from "prop-types";
import {useUsunPozycjeSlownika} from "../../../../api/domain/slowniki/mutations/useUsunPozycjeSlownika.jsx";

export const ModalDeletePozycjeSlownika = ({currPozycja, show, handleClose, slownik}) => {

    const usunPozycjeSlownika = useUsunPozycjeSlownika()

    return <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
            <Modal.Title>Usuwanie pozycji słownika</Modal.Title>
        </Modal.Header>
        <Modal.Body>
            Czy na pewno chcesz usunąć pozycję słownika {currPozycja.nazwa}?
        </Modal.Body>
        <Modal.Footer>
            <Button variant="secondary" onClick={handleClose}>
                Anuluj
            </Button>
            <Button variant="danger" onClick={() => {
                handleClose();
                usunPozycjeSlownika.mutate({id: currPozycja.id, slownik})
            }}>
                Usuń
            </Button>
        </Modal.Footer>
    </Modal>
}

ModalDeletePozycjeSlownika.propTypes = {
    currPozycja: PropTypes.object.isRequired,
    show: PropTypes.bool.isRequired,
    handleClose: PropTypes.func.isRequired,
    id: PropTypes.string.isRequired,
    slownik: PropTypes.string.isRequired
}